<script setup lang="ts">
import LaunchCalendarProduct from './launch-calendar-product.vue';
import { OpenAndUpcomingProductModel } from '@/models/open-and-upcoming-product.model';

interface Props {
  productModelName: string;
  products: OpenAndUpcomingProductModel[];
}

const props = defineProps<Props>();
</script>

<template>
  <div class="product-model">
    <p class="strong-text">{{ props.productModelName }}</p>
    <launch-calendar-product v-for="product in props.products" :key="product.productExternalNumber" :product="product">
    </launch-calendar-product>
  </div>
</template>

<style scoped lang="scss">
.product-model {
  display: flex;
  flex-direction: column;
  padding-top: 15px;

  p {
    text-align: left;
  }
}
</style>
